import React from 'react';
import Slider from 'slider';
import _FavoriteCategoryContainer from './_FavoriteCategoryContainer.scss';
import {Link} from 'react-router-dom';
import {Categories} from 'api';
import {withRouter} from 'react-router-dom';

class FavoriteCategoryContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      limit: 7
    }
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: this.state.limit,
        where: {
          isFavorite: true
        }
      }
    };
    Categories.actions.list.request(params).then(response => {
      this.setState({
        data: response.data
      });
    });
  }

  render() {
    const settings = {
      className: 'slider variable-width favorite-slick',
      dots: false,
      infinite: false,
      centerMode: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1201,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 651,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 551,
        settings: {
          slidesToShow: 1
        }
      }]
    };
    return (
      <section className='center'>
        <div className='favorite-category-container'>
          <div className='favorite-left-content'>
            <p className='title-black'>{this.props.blackTitle}</p>
          </div>
          <div className="favorite-category-border"></div>
          <div className='favorite-right-content'>
            {/* {
              this.state.data.map((item, i) => {
                return(
                  <div className='favorite-item'>
                      <span className='wrap-image'>
                        <Link className='item-link' to={`list-products/${item.id}`}>
                          <i className={`favorite-image ${item.largeIcon}`}/>
                        </Link>
                      </span>
                      <Link className='favorite-name' to={`categories/${item.id}`}>{item.name}</Link>
                  </div>
                )
              })
            } */}
            {/* <div className="favorite-category-content-mobile"> */}
              <Slider {...settings}>
                <div className='favorite-item'>
                  <span className='wrap-image'>
                    <Link className='item-link' to={`list-products/59f1ff4acc2c260ce26843fe`}>
                      <img className='favorite-image' src={require('assets/images/favorite/thaoduoc.jpg')} alt=''/>
                    </Link>
                  </span>
                  <Link className='favorite-name' to={`categories/`}>Thảo dược</Link>
                </div>
                <div className='favorite-item'>
                    <span className='wrap-image'>
                      <Link className='item-link' to={`list-products/5a24b8187b9f190ffea3cc33`}>
                        <img className='favorite-image' src={require('assets/images/favorite/hoaqua.jpg')} alt=''/>
                      </Link>
                    </span>
                    <Link className='favorite-name' to={`categories/`}>Hoa quả, trái cây</Link>
                </div>
                <div className='favorite-item'>
                    <span className='wrap-image'>
                      <Link className='item-link' to={`list-products/5a24b65b7b9f190ffea3cc0b`}>
                        <img className='favorite-image' src={require('assets/images/favorite/cafe-tra.jpg')} alt=''/>
                      </Link>
                    </span>
                    <Link className='favorite-name' to={`categories/`}>Cà phê, Trà, Chè</Link>
                </div>
                <div className='favorite-item'>
                    <span className='wrap-image'>
                      <Link className='item-link' to={`list-products/5a24b4f87b9f190ffea3cbe7`}>
                        <img className='favorite-image' src={require('assets/images/favorite/my-nghe.jpg')} alt=''/>
                      </Link>
                    </span>
                    <Link className='favorite-name' to={`categories/`}>Mây Tre Đan Mỹ Nghệ</Link>
                </div>
                <div className='favorite-item'>
                    <span className='wrap-image'>
                      <Link className='item-link' to={`list-products/5a24b6007b9f190ffea3cc02`}>
                        <img className='favorite-image' src={require('assets/images/favorite/tom-chua.jpg')} alt=''/>
                      </Link>
                    </span>
                    <Link className='favorite-name' to={`categories/`}>Thực Phẩm Đóng Hộp</Link>
                </div>
                <div className='favorite-item'>
                    <span className='wrap-image'>
                      <Link className='item-link' to={`list-products/5a24b6227b9f190ffea3cc06`}>
                        <img className='favorite-image' src={require('assets/images/favorite/nuocmam.jpg')} alt=''/>
                      </Link>
                    </span>
                    <Link className='favorite-name' to={`categories/`}>Gia vị chế biến thực phẩm</Link>
                </div>
                <div className='favorite-item'>
                    <span className='wrap-image'>
                      <Link className='item-link' to={`list-products/5a24b6647b9f190ffea3cc0c`}>
                        <img className='favorite-image' src={require('assets/images/favorite/anlien.jpg')} alt=''/>
                      </Link>
                    </span>
                    <Link className='favorite-name' to={`categories/`}>Thực phẩm ăn liền</Link>
                </div>


                {/* {
                  this.state.data.map((item, i) => {
                    return(
                      <div className='favorite-item'>
                          <span className='wrap-image'>
                            <Link className='item-link' to={`list-products/${item.id}`}>
                              <img className='favorite-image'/>
                            </Link>
                          </span>
                          <Link className='favorite-name' to={`categories/${item.id}`}>{item.name}</Link>
                      </div>
                    )
                  })
                } */}
              </Slider>
            {/* </div> */}
          </div>
        </div>
      </section>
    );
  }
}

FavoriteCategoryContainer.defaultProps = {
  blackTitle: 'Danh mục nổi bật'
}

export default withRouter(FavoriteCategoryContainer);



// WEBPACK FOOTER //
// ./components/home/sub-view/FavoriteCategoryContainer.jsx